"use client"

import { useEffect } from "react"
import { AlertCircle, RefreshCw } from "lucide-react"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log error to error reporting service
    console.error("Global error:", error)
  }, [error])

  return (
    <html lang="en">
      <body>
        <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4 text-center">
          {/* Error Icon */}
          <div className="mb-8 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
            <AlertCircle className="h-8 w-8 text-destructive" />
          </div>
          
          {/* Error Message */}
          <h1 className="mb-4 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Something went wrong
          </h1>
          
          <p className="mb-2 text-lg text-muted-foreground max-w-md">
            A critical error occurred. Please try refreshing the page.
          </p>
          
          {error.digest && (
            <p className="mb-8 text-sm text-muted-foreground">
              Error ID: {error.digest}
            </p>
          )}

          {/* Action */}
          <button
            onClick={reset}
            className="inline-flex items-center gap-2 rounded-lg bg-accent px-6 py-3 text-base font-medium text-white transition-colors hover:bg-accent/90"
          >
            <RefreshCw className="h-4 w-4" />
            Try Again
          </button>
        </div>
      </body>
    </html>
  )
}





